import { UserRole } from '@features/authentication/types';
import { RoleConfigMap } from './routeTypes';
import { systemAdminConfig } from './systemAdminRoutes';
import { lecturerConfig } from './lecturerRoutes';
import { courseRepresentativeConfig } from './courseRepresentativeRoutes';
import { universityAdminConfig } from './universityAdminRoutes';
import { instituteAdminConfig } from './instituteAdminRoutes';

export const roleConfigs: RoleConfigMap = {
  SYSTEM_ADMIN: systemAdminConfig,
  PROFESSOR: lecturerConfig,
  COURSE_REPRESENTATIVE: courseRepresentativeConfig,
  UNIVERSITY_ADMIN: universityAdminConfig,
  FACULTY_ADMIN: instituteAdminConfig,
};

export const getConfigForRole = (role: UserRole | string) => {
  // Handle both enum values and string values
  // When roles come from the API, they might be strings
  let config;

  if (typeof role === 'string') {
    // Try to match the string directly (for when roles come as strings from API)
    config = roleConfigs[role as UserRole];

    // If not found, try to match against enum values
    if (!config) {
      const enumKey = Object.keys(UserRole).find(
        (key) => UserRole[key as keyof typeof UserRole] === role
      );
      if (enumKey) {
        config = roleConfigs[UserRole[enumKey as keyof typeof UserRole]];
      }
    }
  } else {
    config = roleConfigs[role];
  }

  return config;
};

export * from './routeTypes';
export * from './commonRoutes';
